
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyAQlvGslr__de8bEPwBKEkvylYkYIpIsto",
    authDomain: "lms-eyecare-1e31b.firebaseapp.com",
    projectId: "lms-eyecare-1e31b",
    storageBucket: "lms-eyecare-1e31b.firebasestorage.app",
    messagingSenderId: "737634943974",
    appId: "1:737634943974:web:487d6e55a9aa80657ecc27"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection };  // Correct export

